// 后端现有VIP汇总按 rebateRules.rate 读取默认比例，不推断未返回的分类比例。
export function vipDefaultRebateRate(value) {
  try {
    const rules=typeof value==='string'?JSON.parse(value):value
    const rate=rules && !Array.isArray(rules) ? rules.rate : null
    return rate != null && /^\d+(?:\.\d+)?$/.test(String(rate)) ? String(rate) : null
  } catch { return null }
}

// 门槛只做字符串分组，保留非零小数，避免大金额经 Number 损失精度。
export function formatVipThreshold(value) {
  const match=/^(\d+)(?:\.(\d+))?$/.exec(String(value ?? '').trim())
  if(!match)return '—'
  const fraction=(match[2] || '').replace(/0+$/,'')
  return match[1].replace(/\B(?=(\d{3})+(?!\d))/g,',')+(fraction?`.${fraction}`:'')
}
